import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import cn from 'classnames';
import Button from '../Button';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: '8px',
    boxShadow: '0 2px 2px 0 rgba(9, 66, 135, 0.25)',
    backgroundColor: '#0067c5',
    minWidth: '67px',
    minHeight: '32px',
    padding: '4px 10px',
    '&:hover': {
      backgroundColor: colors.blueChip,
    },
  },
  icon: {
    marginRight: 8,
    lineHeight: '1px !important',
  },
  btnTxt: {
    fontSize: fontSize.medium,
  },
}));

const iconsMap = {
  edit: <EditIcon fontSize="small" />,
};

const RectangleButton = ({ btnText, iconType, className, ...rest }) => {
  const classes = useStyles();

  return (
    <Button {...rest} className={cn(classes.button, className)} >
      {iconType && <span className={classes.icon}>{iconsMap[iconType]}</span>}
      <span className={classes.btnTxt}>{btnText}</span>
    </Button>
  );
};

RectangleButton.propTypes = {
  btnText: PropTypes.string.isRequired,
  iconType: PropTypes.string,
};

export default RectangleButton;
